module.exports = __webpack_public_path__ + "img/program-tfmirror.c207690a.jpg";